export default (index) => {
  if (typeof window.tC.event.select_content === "function") {
    window.tC.event.select_content(this, {
      card_number: index + 1,
      content_type: "carousel card",
      item_id: "card " + (index + 1),
    });
  }
};
